import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

function BackArrow() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 12H5m0 0 6-6m-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

/**
 * Duolingo's register-flow top chrome: a back arrow and one rounded bar whose
 * fill grows continuously with the step, not a segmented one.
 */
export default function DuoProgressHeader({
  step,
  totalSteps,
}: {
  /** 1-based position of the current screen in the flow. */
  step: number
  totalSteps: number
}) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const showBack = step > 1

  return (
    <div className="flex shrink-0 items-center gap-3">
      <button
        aria-label={t('shared.back', { defaultValue: 'Back' })}
        className={twMerge(
          'text-duo-line-dark hover:text-duo-ink flex h-9 w-9 shrink-0 items-center justify-center transition-colors',
          !showBack && 'invisible',
        )}
        data-testid="button-back"
        onClick={() => navigate(-1)}
        type="button"
      >
        <BackArrow />
      </button>

      <div
        aria-label={t('shared.progress', { defaultValue: 'Progress' })}
        aria-valuemax={totalSteps}
        aria-valuemin={0}
        aria-valuenow={step}
        className="bg-duo-line h-4 grow overflow-hidden rounded-full"
        role="progressbar"
      >
        <div
          className="bg-duo-primary h-full rounded-full transition-[width] duration-300 ease-out"
          style={{ width: `${Math.round((step / totalSteps) * 100)}%` }}
        />
      </div>
    </div>
  )
}
